import isWithinRange from "date-fns/is_within_range";
import DateInterval from "../DateInterval";

const isWithinAnInterval = (day: Date, intervals: DateInterval[]): boolean =>
  intervals.some(interval => isWithinRange(day, interval.start, interval.end));

export default isWithinAnInterval;
